import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 15vw;
    padding-bottom: 10vh;

    color: var(--darkgreen);

    h2{
        font-family: Druk Wide Bold;
        font-size: 36px;
        margin-bottom: 0;
    }

    .details{
        margin-top: 3vh;
        width: 60%;

        font-family: IBM Plex Mono Regular;

        p{
            font-size: 2vh;
        }

        .item{
            display: flex;
            align-items: center;

            margin-top: 3vh;
            padding-bottom: 3vh;
            border-bottom: 1px solid rgba(177, 178, 179, 0.3);

            .field{
                font-family: IBM Plex Mono Bold;
                text-transform: uppercase;
                width: 25vw;
            }

            p{
                text-transform: capitalize;
                margin: 0;
            }
        }
    }

    @media(max-width: 1000px)
    {
        h2{
            text-align: center;
        }

        .details{
            width: 80%;

            .item{
                .field{
                    width: 35vw;
                }
            }
        }
    }
`;

export default function About({ product })
{
    var thcMake = ""
    var cbdMake = ""

    if(product?.potencyThc?.formatted && product?.potencyThc?.formatted !== "")
    {
        thcMake += product?.potencyThc?.formatted.split(" ").join("");
    }
    else
    {
        thcMake += "0%";
    }

    if(product?.potencyCbd?.formatted && product?.potencyCbd?.formatted !== "")
    {
        cbdMake += product?.potencyCbd?.formatted.split(" ").join("");
    }
    else
    {
        cbdMake += "0%";
    }

    return(
        <Wrapper>
            <h2>About this Product</h2>

            <div className="details">
                <p className="description">{product?.description}</p>

                <div className="item">
                    <p className="field">Brand</p>
                    <p>{product?.brand.name}</p>
                </div>

                <div className="item">
                    <p className="field">THC</p>
                    <p>{thcMake}</p>
                </div>

                <div className="item">
                    <p className="field">CBD</p>
                    <p>{cbdMake}</p>
                </div>

                <div className="item">
                    <p className="field">Strain Type</p>
                    <p>{ product?.strainType?.toLowerCase().replace("_", " ")}</p>
                </div>

                <div className="item">
                    <p className="field">Effects</p>
                    <p>{ (product?.effects && product.effects?.length > 0) ? product.effects.join(", ").toLowerCase() : 'N/A' }</p>
                </div>

                <div className="item">
                    <p className="field">Category</p>
                    <p>{ product?.category ? product.category.toLowerCase().replace("_", " ") : 'N/A' }</p>
                </div>

                <div className="item">
                    <p className="field">Subcategory</p>
                    <p>{ product?.subcategory ? product.subcategory.toLowerCase().replace("_", " ") : 'N/A' }</p>
                </div>
            </div>
        </Wrapper>
    )
}